import repository from "../Repository";

export default {
  async list(screenId) {
    return repository.post(
      `authority_check`,
      {},
      {
        headers: {
          s: screenId
        }
      }
    );
  }
};
